import type { AdminStoreSummary } from '@/client/types/stores';
import { cn } from '@/lib/utils';

import { STORE_SEGMENTS } from './segments';

const tile =
  'flex min-w-0 flex-col rounded-xl border bg-white px-3 py-2.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

/** Headline counts that double as filters: click a tile to narrow the roster. */
export const StoresSummary: React.FC<{
  summary?: AdminStoreSummary | null;
  active: string[];
  onToggle: (key: string) => void;
  onClear: () => void;
}> = ({ summary, active, onToggle, onClear }) => (
  <div className="mb-4 grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-12">
    <button
      type="button"
      aria-pressed={active.length === 0}
      onClick={onClear}
      className={cn(tile, active.length === 0 ? 'border-gray-900 ring-1 ring-gray-900' : 'border-gray-200 hover:border-gray-300')}
    >
      <span className="text-xl font-bold tabular-nums text-gray-900">{summary ? summary.total.toLocaleString() : '—'}</span>
      <span className="truncate text-xs text-gray-500">All stores</span>
    </button>
    {STORE_SEGMENTS.map((seg) => {
      const count = summary ? seg.count(summary) : null;
      const on = active.includes(seg.key);
      return (
        <button
          key={seg.key}
          type="button"
          title={seg.hint}
          aria-pressed={on}
          onClick={() => onToggle(seg.key)}
          className={cn(tile, on ? 'border-gray-900 ring-1 ring-gray-900' : 'border-gray-200 hover:border-gray-300')}
        >
          <span className={cn('text-xl font-bold tabular-nums', count ? seg.tone : 'text-gray-300')}>
            {count == null ? '—' : count.toLocaleString()}
          </span>
          <span className="truncate text-xs text-gray-500">{seg.label}</span>
        </button>
      );
    })}
  </div>
);
